var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0004 9C22.9004 8.6 22.6004 8.4 22.2004 8.3L15.8004 7.4L12.9004 1.6C12.7004 1.2 12.4004 1 12.0004 1C11.6004 1 11.3004 1.2 11.1004 1.6L8.20043 7.4L1.90043 8.3C1.50043 8.4 1.20043 8.6 1.00043 9C0.800428 9.4 1.00043 9.8 1.30043 10L5.90043 14.4L4.80043 20.8C4.70043 21.2 4.90043 21.6 5.20043 21.8C5.50043 22 5.90043 22.1 6.30043 21.9L12.0004 18.9L17.7004 21.9C17.9004 22 18.0004 22 18.2004 22C18.4004 22 18.6004 21.9 18.8004 21.8C19.1004 21.6 19.3004 21.2 19.2004 20.8L18.1004 14.4L22.7004 10C23.0004 9.8 23.1004 9.4 23.0004 9ZM16.3004 13.4C16.1004 13.6 16.0004 14 16.0004 14.3L16.9004 19.2L12.5004 16.9C12.4004 16.8 12.2004 16.8 12.0004 16.8C11.8004 16.8 11.7004 16.8 11.5004 16.9L7.10043 19.2L8.00043 14.3C8.10043 14 7.90043 13.6 7.70043 13.4L4.20043 10L9.00043 9.3C9.30043 9.3 9.60043 9 9.80043 8.8L12.0004 4.3L14.2004 8.8C14.3004 9 14.6004 9.2 15.0004 9.3L19.9004 10L16.3004 13.4Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconStar.79f11ee4a424a23f576d123af08b7c95.svg";